import React from 'react';

export const manualUploadPageTitle =
  'Upload a statement in support of mental health conditions';

export const manualUploadPageDescription = (
  <p>
    Upload your Statement in Support of Claimed Mental Health Disorder(s) Due to
    an In-Service Traumatic Event(s) to support your claim.
  </p>
);

export const manualUploadAlertText =
  'We’ve deleted this file about your mental health statement.';

export const manualUploadRequirementsTextTitle = (
  <span>Select a file to upload</span>
);
